import React, { FC } from "react";
import NoAttemptsIcon from "../../../../../assets/placeholder/no-attempts.svg";
import "./emptyScreen.scss";
interface AnalyticsEmptyScreenProps {
  title: string;

}
export const AnalyticsEmptyScreen: FC<AnalyticsEmptyScreenProps> = ({
  title
}) => {
  return (
    <div className="analytics-empty-screen__container">
      <img src={NoAttemptsIcon} />
      <p>{title}</p>
    </div>
  );
};
